
import { defineComponent } from 'vue'
import PzldjdxRoomSearch from './components/PzldjdxRoomSearch.vue'
import PzldjdxRoomSearchForm from './components/PzldjdxRoomSearchForm.vue'

export default defineComponent({
  name: 'App',
  components: {
    PzldjdxRoomSearch,
    PzldjdxRoomSearchForm,
  },
})
